/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const listBmsSettings = /* GraphQL */ `
  query ListBmsSettings {
    listBmsSettings
  }
`;
export const getChannelDashboardStats = /* GraphQL */ `
  query GetChannelDashboardStats {
    getChannelDashboardStats
  }
`;
export const getSystemHealth = /* GraphQL */ `
  query GetSystemHealth {
    getSystemHealth
  }
`;
export const bmsListKnowledgeBaseFiles = /* GraphQL */ `
  query BmsListKnowledgeBaseFiles($input: BmsListKnowledgeBaseFilesInput!) {
    bmsListKnowledgeBaseFiles(input: $input)
  }
`;
export const bmsSearchKnowledgeBase = /* GraphQL */ `
  query BmsSearchKnowledgeBase($input: BmsSearchKnowledgeBaseInput!) {
    bmsSearchKnowledgeBase(input: $input)
  }
`;
export const bmsGetCallFeedback = /* GraphQL */ `
  query BmsGetCallFeedback($input: BmsGetCallFeedbackInput) {
    bmsGetCallFeedback(input: $input)
  }
`;
export const listEmailTemplates = /* GraphQL */ `
  query ListEmailTemplates {
    listEmailTemplates
  }
`;
export const listEmailTemplateVariables = /* GraphQL */ `
  query ListEmailTemplateVariables($input: ListEmailTemplateVariablesInput!) {
    listEmailTemplateVariables(input: $input)
  }
`;
export const getCurrentUserDetails = /* GraphQL */ `
  query GetCurrentUserDetails {
    getCurrentUserDetails
  }
`;
export const listAdminUsers = /* GraphQL */ `
  query ListAdminUsers {
    listAdminUsers
  }
`;
export const listOrganizations = /* GraphQL */ `
  query ListOrganizations($input: ListOrganizationsInput) {
    listOrganizations(input: $input)
  }
`;
export const checkOrgNameAvailability = /* GraphQL */ `
  query CheckOrgNameAvailability($input: CheckOrgNameAvailabilityInput) {
    checkOrgNameAvailability(input: $input)
  }
`;
export const getOrgSettings = /* GraphQL */ `
  query GetOrgSettings($input: GetOrgSettingsInput!) {
    getOrgSettings(input: $input)
  }
`;
export const getOrgSummary = /* GraphQL */ `
  query GetOrgSummary($input: GetOrgSummaryInput!) {
    getOrgSummary(input: $input)
  }
`;
export const getOrgDetailsForLandingPage = /* GraphQL */ `
  query GetOrgDetailsForLandingPage($input: GetOrgDetailsForLandingPageInput!) {
    getOrgDetailsForLandingPage(input: $input)
  }
`;
export const getOrgDetailsFromSipId = /* GraphQL */ `
  query GetOrgDetailsFromSipId($input: getOrgDetailsFromSipIdInput) {
    getOrgDetailsFromSipId(input: $input)
  }
`;
export const listCallerIds = /* GraphQL */ `
  query ListCallerIds($input: listCallerIdsInput) {
    listCallerIds(input: $input)
  }
`;
export const listCallHistory = /* GraphQL */ `
  query ListCallHistory($input: listCallHistoryInput) {
    listCallHistory(input: $input)
  }
`;
export const getDasbBoardData = /* GraphQL */ `
  query GetDasbBoardData($input: getDasbBoardDataInput) {
    getDasbBoardData(input: $input)
  }
`;
export const getCostMetrics = /* GraphQL */ `
  query GetCostMetrics($input: getCostMetricsInput) {
    getCostMetrics(input: $input)
  }
`;

export const getEngineCostByOrgBreakdown = /* GraphQL */ `
  query GetEngineCostByOrgBreakdown($input: getCostBreakdownInput) {
    getEngineCostByOrgBreakdown(input: $input)
  }
`;

export const getAwsCostBreakdown = /* GraphQL */ `
  query GetAwsCostBreakdown($input: getCostBreakdownInput) {
    getAwsCostBreakdown(input: $input)
  }
`;
export const listCreditRequests = /* GraphQL */ `
  query ListCreditRequests($input: listCreditRequestsInput) {
    listCreditRequests(input: $input)
  }
`;
export const getUniqueCallerStats = /* GraphQL */ `
  query GetUniqueCallerStats($input: getUniqueCallerStatsInput) {
    getUniqueCallerStats(input: $input)
  }
`;
export const listTransactions = /* GraphQL */ `
  query ListTransactions($input: listTransactionsInput!) {
    listTransactions(input: $input)
  }
`;
export const listAuditLogs = /* GraphQL */ `
  query ListAuditLogs($input: listAuditLogsInput!) {
    listAuditLogs(input: $input)
  }
`;
export const listOnCallActions = /* GraphQL */ `
  query ListOnCallActions($input: ListOnCallActionsInput!) {
    listOnCallActions(input: $input)
  }
`;
export const getOnCallAction = /* GraphQL */ `
  query GetOnCallAction($input: GetOnCallActionInput!) {
    getOnCallAction(input: $input)
  }
`;
export const listOrgAgentsForRedirect = /* GraphQL */ `
  query ListOrgAgentsForRedirect($input: ListOrgAgentsForRedirectInput!) {
    listOrgAgentsForRedirect(input: $input)
  }
`;
export const getTestCallResult = /* GraphQL */ `
  query GetTestCallResult($input: GetTestCallResultInput!) {
    getTestCallResult(input: $input)
  }
`;
export const listActionTemplates = /* GraphQL */ `
  query ListActionTemplates {
    listActionTemplates
  }
`;
